import React, { useState, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import { notificationCenterWidth, RightSideBarWidth } from '../../../styleVariables';
import useMountEffect from '../../../mountEffect';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import * as logger from "../../../logger";
import AddRoundedIcon from '@material-ui/icons/AddRounded';

import { connect } from 'react-redux';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import {
  updateChatView, toggleChatSupport
} from "../../../store/actions/userActionCreators";
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { freshChat } from '../../../configs/configs';
import FreshChat from 'react-freshchat';
import MobileStepper from '@material-ui/core/MobileStepper';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { biltyContinueClick } from '../../../store/actions/tripActionCreator';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ExcelIcon, PdfIconWhite } from '../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: RightSideBarWidth,
    maxWidth: RightSideBarWidth,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  simTrackingDrawer: {
    width: 430,
    maxWidth: 430,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  paymentDetailsDrawer: {
    width: 475,
    maxWidth: 475,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  addPaymentSupplierrDrawer: {
    width: 538,
    maxWidth: 538,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  biltyDrawer: {
    width: 420,
    maxWidth: 420,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  drawerTripPaper: {
    width: 950,
    maxWidth: 950,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  drawerPaperTruckBook: {
    width: RightSideBarWidth,
    maxWidth: RightSideBarWidth,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99,
    backgroundColor: '#f1f1f3'
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  backdrop: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    }
  },
  container: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1,
    flexGrow: 1
  },
  tabsRoot: {
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: '50%',
    color: theme.palette.text.primary
  },
  padding: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1) * 2,
      paddingRight: theme.spacing(1) * 2,
      paddingTop: theme.spacing(1) * 2,
      paddingBottom: theme.spacing(1) * 2
    },
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(1) * 3,
      paddingRight: theme.spacing(1) * 3,
      paddingTop: theme.spacing(1) * 2,
      paddingBottom: theme.spacing(1) * 2
    }
  },
  disabledButton: {
    padding: '9px 26px 11px 28px !important',
    borderRadius: '4px !important',
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1) !important',
    backgroundColor: '#C0C0C0 !important',
    fontSize: '14px !important',
    fontWeight: 'bold !important',
    color: '#fff !important',
    height: '36px !important',
    textTransform: 'capitalize !important',
    letterSpacing: '1px !important'
  },
  fsV1: {
    fontSize: '26px !important'
  },
  bullet: {
    display: "inline-block",
    margin: "0 8px",
    transform: "scale(1.7)",
    color: "#c7c7c7"
  },
  bulletV1: {
    display: "inline-block",
    marginLeft: 8,
    marginRight: 8,
    transform: "scale(1.3)",
    color: "#c7c7c7"
  },
  vehicleNumber: {
    fontSize: 14,
    fontWeight: 500,
    marginLeft: 16
  },
  truckType: {
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'capitalize'
  },
  vehicleNumberSuffix: {
    color: '#0033cc'
  },
  divTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  addOtherDocument: {
    color: '#fff',
    height: 36,
    paddingTop: 9,
    paddingBottom: 11,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: 14,
    fontWeight: 300,
    borderRadius: 4,
    textTransform: 'capitalize',
    backgroundColor: '#09101e',
    boxShadow: '0 1px 1px 0 rgb(22 29 37 / 10%)',
    '&:hover': {
      backgroundColor: '#09101e'
    }
  },
  bColorW: {
    backgroundColor: 'white'
  },
  driverDetailsButton: {
    backgroundColor: '#0033cc',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    letterSpacing: '1px',
    paddingTop: 15,
    paddingBottom: 15,
    fontSize: 16,
    width: '100%',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  sideBarDialogActionsV1: {
    paddingTop: 16,
    paddingBottom: 16,
    backgroundColor: 'white'
  },
  sideBarDialogContentV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 20,
    paddingBottom: 20,
  },
  splitV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  simTrackingTitle: {
    paddingTop: 4,
    paddingBottom: 4,
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    '& .MuiIconButton-root': {
      top: 'unset !important'
    }
  },
  truckBookTitle: {
    '& .MuiIconButton-root': {
      top: '7px !important'
    }
  },
  vehicleNumberV1: {
    '&:last-child': {
      color: '#0033cc',
      marginLeft: 4
    }
  },
  divV1: {
    fontSize: 14,
    color: 'grey'
  },
  chatSupportButton: {
    backgroundColor: '#0033cc',
    color: 'white',
    fontWeight: 'bold',
    borderRadius: 8,
    width: '100%',
    paddingTop: 16,
    paddingBottom: 16,
    letterSpacing: '1px',
    fontSize: 16,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#0033cc'
    },
  },
  buttonText: {
    marginTop: '-4px',
    marginLeft: '8px'
  },
  iconV1: {
    color: 'white', fontSize: 28
  },
  divSupport: {
    fontWeight: 300,
    width: '100%',
    textAlign: 'center',
    fontSize: 18
  },
  biltyCancel: {
    textTransform: 'capitalize',
    fontWeight: 300,
    backgroundColor: '#efeff2',
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 38,
    paddingRight: 38,
    marginRight: 16,
    borderRadius: 4
  },
  biltyNext: {
    textTransform: 'capitalize',
    fontWeight: 300,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 54,
    paddingRight: 54,
    color: 'white',
    backgroundColor: '#5170f0',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#5170f0',
    }
  },
  biltyContent: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    paddingTop: '0px !important'
  },
  biltyContentV1: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important'
  },
  createBiltyButton: {
    color: 'white',
    fontWeight: 500,
    backgroundColor: '#5170f0',
    paddingTop: 17,
    paddingBottom: 17,
    borderRadius: 8,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#5170f0'
    }
  },
  biltyHomeStepsTitle: {
    paddingTop: 8,
    paddingBottom: '8px !important',
    paddingRight: '12px',
    paddingLeft: 24
  },
  biltyContinueButton: {
    backgroundColor: '#5170f0',
    color: 'white',
    fontWeight: 500,
    paddingTop: 17,
    paddingBottom: '17px !important',
    textTransform: 'capitalize',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#5170f0'
    }
  },
  bColorGrey: {
    backgroundColor: '#f1f1f3',
    paddingLeft: '16px !important',
    paddingRight: '16px !important',
    paddingTop: '14px !important',
    paddingBottom: '14px !important'
  },
  biltyHomeStepsActions: {
    backgroundColor: 'white',
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 20,
    paddingTop: 24
  },
  biltyFlowTitle: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: '0px !important',
    paddingTop: '12px !important',
    boxShadow: '0 4px 4px 0 rgba(0, 13, 23, 0.06)',
  },
  closeButton: {
    color: '#c0c0c0',
    fontSize: 18
  },
  divV4: {
    paddingLeft: 24,
    paddingRight: 12,
    paddingBottom: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  divV5: {
    display: 'flex',
    flexDirection: 'column'
  },
  stepperProgress: {
    width: '100% !important'
  },
  divStep: {
    color: '#6b778c',
    fontSize: 12,
  },
  divTitleBilty: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  biltyConsignorConsigneeActions: {
    display: 'flex',
    backgroundColor: 'white',
    padding: 8,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  backButton: {
    borderRadius: 8,
    backgroundColor: '#f1f1f3',
    textTransform: 'capitalize',
    color: 'black',
    fontWeight: 500,
    paddingLeft: 82,
    paddingRight: 82,
    paddingTop: 17,
    paddingBottom: 17,
    '&:hover': {
      backgroundColor: '#f1f1f3',
    }
  },
  nextButton: {
    borderRadius: 8,
    color: 'white',
    fontWeight: 500,
    backgroundColor: '#5170f0',
    textTransform: 'capitalize',
    paddingLeft: 82,
    paddingRight: 82,
    paddingTop: 17,
    paddingBottom: 17,
    '&:hover': {
      backgroundColor: '#5170f0',
    }
  },
  disableButton: {
    borderRadius: 8,
    color: 'white !important',
    fontWeight: 500,
    backgroundColor: '#a1a1a1 !important',
    textTransform: 'capitalize',
    paddingLeft: 82,
    paddingRight: 82,
    paddingTop: 17,
    paddingBottom: 17,
    '&:hover': {
      backgroundColor: '#a1a1a1 !important',
    }
  },
  biltyContentV2: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    paddingTop: '0px !important',
    paddingBottom: '24px !important'
  },
  divTimeLine: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  biltyTimeLineTitle: {
    paddingTop: 4,
    paddingBottom: '4px !important',
    paddingLeft: 32,
    paddingRight: 20,
    boxShadow: '0 1px 8px rgb(0 0 0 / 30%)'
  },
  biltyTimeLineActions: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    paddingBottom: 16
  },
  closeIcon: {
    fontSize: 20
  },
  fromReports: {
    width: 614,
    maxWidth: 614,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  reportTitle: {
    paddingTop: 4,
    paddingBottom: '4px !important',
    paddingLeft: 24,
    paddingRight: 12,
    boxShadow: '0 1px 8px rgb(0 0 0 / 30%)'
  },
  reportTitleV1: {
    paddingTop: 4,
    paddingBottom: '4px !important',
    paddingLeft: 12,
    paddingRight: 12,
    boxShadow: '0 1px 8px rgb(0 0 0 / 30%)'
  },
  divTitleReport: {
    fontSize: 20,
    color: '#0b1323',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center'
  },
  arrowBackIcon: {
    fontSize: 24,
    color: 'grey'
  },
  divReportAlign: {
    display: 'flex',
    alignItems: 'center'
  },
  closeIcon24: {
    fontSize: 24
  },
  divReportsTitle: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  mrV1: {
    marginRight: 4
  },
  downloadExcelButton: {
    backgroundColor: '#09101e',
    color: 'white',
    borderRadius: 4,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 12,
    paddingRight: 12,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#09101e'
    }
  },
  viewPdfButton: {
    backgroundColor: '#09101e',
    color: 'white',
    borderRadius: 4,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 12,
    paddingRight: 12,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#09101e'
    }
  },
  excelIcon: {
    marginLeft: 10
  },
  truckIncomeReport: {
    padding: '0px !important'
  },
  truckIncomeReportActions: {
    paddingTop: 20,
    paddingBottom: '20px !important',
    paddingRight: 24,
    paddingLeft: 24,
    backgroundColor: '#f1f1f3'
  },
  truckIncomeReportActionsWhite: {
    paddingTop: 20,
    paddingBottom: '20px !important',
    paddingRight: 24,
    paddingLeft: 24,
    backgroundColor: 'white'
  },
  paymentSideBarActions: {
    paddingTop: 20,
    paddingBottom: '20px !important',
    paddingRight: 24,
    paddingLeft: 24,
    backgroundColor: 'white'
  },
  addPaymentSideBarActions: {
    paddingTop: 24,
    paddingBottom: '24px !important',
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: 'white'
  },
  addPaymentSideBarActionsV1: {
    paddingTop: 24,
    paddingBottom: '24px !important',
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'normal !important'
  },
  vehicleNumberReport: {
    fontSize: 14,
    color: '#0b1323',
    fontWeight: 'normal',
    '&:last-child': {
      color: '#2c5de5',
      marginLeft: 6
    }
  },
  mlV1: {
    marginLeft: 16,
  },
  vehicleNumberTruckIncome: {
    marginLeft: 16,
    display: 'flex'
  },
  partyName: {
    fontWeight: 'normal',
    fontSize: 14,
    marginLeft: 16,
    marginTop: 2
  },
  pdfIcon: {
    fontSize: 20,
    marginLeft: 10
  },
  paymentsSupplier: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 30,
    paddingRight: 30,
    backgroundColor: '#f6f6f8'
  },
  titlePaymentSupplier: {
    paddingBottom: '12px !important',
  },
  divTitleV1: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
  },
  editTripCtaV1: {
    backgroundColor: 'white',
    borderRadius: 4,
    color: '#1461d2',
    minWidth: 80,
    padding: '8px',
    paddingTop: 6,
    paddingBottom: 6,
    textTransform: 'capitalize',
    border: 'solid 1px #1461d2',
    marginTop: 1
  },
  deleteTripCtaV1: {
    backgroundColor: 'white',
    borderRadius: 4,
    color: '#de1c22',
    minWidth: 80,
    padding: '8px',
    paddingTop: 5,
    paddingBottom: 5,
    marginRight: 16,
    marginLeft: 16,
    textTransform: 'capitalize',
    border: 'solid 1px #de1c22',
    marginTop: 1
  },
  divActionsPayment: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: "space-between"
  },
  divPaymentAlign: {
    display: 'flex',
    alignItems: 'center'
  },
  deleteIconV1: {
    fontSize: '14px !important'
  },
  editIconv1: {
    fontSize: '14px !important'
  },
  chooseTripButton: {
    backgroundColor: '#09101e',
    color: 'white',
    borderRadius: '4px !important',
    marginLeft: '16px !important',
    textTransform: 'capitalize',
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 32,
    paddingRight: 32,
    fontWeight: 300,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1) !important',
    '&:hover': {
      backgroundColor: '#09101e'
    }
  },
  chooseTripButtonDisabled: {
    backgroundColor: '#dadada',
    color: 'rgba(11, 19, 35, 0.6)',
    borderRadius: '4px !important',
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1) !important',
    marginLeft: '16px !important',
    textTransform: 'capitalize',
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 32,
    paddingRight: 32,
    fontWeight: 300,
    '&:hover': {
      backgroundColor: '#dadada'
    }
  },
  confirmDisabled: {
    backgroundColor: '#dadada !important',
    color: 'rgba(11, 19, 35, 0.6) !important',
    borderRadius: '4px !important',
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1) !important',
    marginLeft: '16px !important',
    textTransform: 'capitalize',
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 32,
    paddingRight: 32,
    fontWeight: 300,
    '&:hover': {
      backgroundColor: '#dadada'
    }
  },
  backButtonSupplier: {
    textTransform: 'capitalize',
    padding: '6px 16px',
    borderRadius: '4px !important',
    border: 'solid 1px #d8dce6',
    background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
    boxShadow: '0 1px 1px 0 rgb(22 29 37 / 5%), inset 0 2px 0 0 rgb(255 255 255 / 5%)',
    fontSize: 14,
    fontWeight: 300,
    '&:hover': {
      background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
      boxShadow: 'none'
    }
  },
  paymentDetailSingleSupplierTitle: {
    paddingTop: '8px !important',
    paddingBottom: '8px !important'
  },
  doneV1: {
    color: '#00875a',
    fontSize: 24
  },
  errorV1: {
    color: '#e86825',
    fontSize: 24
  },
  paymentFullyAllocated: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    backgroundColor: '#d6f3e2',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16
  },
  paymentPartiallyAllocated: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    backgroundColor: '#ffdbc1',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16
  },
  divAlign: {
    marginLeft: 14,
    display: 'flex',
    alignItems: 'center'
  },
  fw300: {
    fontWeight: 300
  },
  divAlignButtons: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  }
}));

const RightSideBar = ({
  rightSideBarOpen,
  toggleRightSideBar,
  user,
  children,
  sideBarName,
  sideBarTitle,
  sideBarType,
  handleSubmit,
  dispatchChatView,
  dispatchToggleChatSupport,
  actionInfo,
  action,
  vehicleNumberValue,
  truckType,
  addTripClicked,
  addExpense,
  vehicle,
  fromAddTrip,
  onValidate,
  confirmText,
  fromSimTracking,
  addDriverDetail,
  fromCheckApproval,
  sourceLocation,
  destinationLocation,
  splitDesign,
  nextClick,
  fromBiltyHome,
  fromBiltyFlow,
  createBiltyClick,
  dividerNotRequired,
  fromBiltyHomeSteps,
  continueClick,
  titleType,
  trip,
  dispatchBiltyContinueClick,
  biltyTimeLine,
  previewBilty,
  backClick,
  stepCountValue,
  checkAllTrueBiltyFlow,
  showBack,
  showDownloadExcel,
  showBackReports,
  fromTruckIncomeReport,
  fromPartyIncomeReport,
  partyNameValue,
  fromProfitLossReport,
  showViewPdf,
  paidOnline,
  fromPaymentSideBarSupplier,
  titleEighteen,
  chooseTripConfirm,
  deleteClick,
  allocatedTextValue,
  fullyAllocatedFlag,
  tripsError
}) => {
  const [validate, setValidate] = useState(false);
  const [updateChatView, setChatView] = useState(false);
  const [progress, setProgress] = useState(25);
  const [checkDataPopulated, setCheckDataPopulated] = useState(false);
  const [checkStatusAllTrue, setCheckStatusAllTrue] = useState(false);
  let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

  const classes = useStyles();

  useMountEffect(() => {

  });

  const handleAddTrip = () => {
    addTripClicked();
  }

  const handleAddExpense = () => {
    addExpense();
  }

  useEffect(() => {

    setProgress(stepCountValue * 25);

  }, [stepCountValue])

  useEffect(() => {
    dispatchChatView(false);
  }, []);

  useEffect(() => {

    if (onValidate && Object.keys(onValidate).length !== 0 && onValidate.constructor === Object) {
      setValidate(true);
    } else {
      setValidate(false);
    }
  }, [onValidate]);

  useEffect(() => {

    if (trip && trip.biltyDataPopulated) {
      setCheckDataPopulated(true)
    } else {
      setCheckDataPopulated(false);
    }

  }, [trip.biltyDataPopulated]);

  useEffect(() => {

    let checkAllTrue;
    if (checkAllTrueBiltyFlow) {
      setCheckStatusAllTrue(checkAllTrueBiltyFlow)
    } else {
      if (user && user.singleTripData && user.singleTripData.elr_status) {
        checkAllTrue = Object.keys(user.singleTripData.elr_status).every(k => user.singleTripData.elr_status[k]);
        setCheckStatusAllTrue(checkAllTrue);
      }
    }

  }, [rightSideBarOpen, trip.singleTripData, checkAllTrueBiltyFlow])

  const handleClose = () => {

    dispatchChatView(true);
    if (toggleRightSideBar) {
      toggleRightSideBar()
    }
  }
  const handleSave = () => {
    dispatchChatView(true);
    if (handleSubmit) {
      handleSubmit()
    }
  }

  const handleDriverDetailClicked = () => {
    addDriverDetail();
  }

  const handleBiltyContinueClick = () => {
    trip.singleConsignee = {};
    trip.singleConsignor = {};
    let progressValue;
    dispatchBiltyContinueClick(true);
    if (checkDataPopulated) {

      if (progress <= 100) {
        progressValue = progress + 25;
      } else {
        progressValue = 100;
      }
      // setProgress((prevProgress) => (prevProgress < 100 ? prevProgress + 25 : 100))
      continueClick(progressValue);
    }
  }

  const handleBiltyContinueClickStep1 = () => {
    // trip.singleConsignee = {};
    // trip.singleConsignor = {};
    let progressValue = progress + 25;
    // setProgress((prevProgress) => (prevProgress < 100 ? prevProgress + 25 : 100))
    continueClick(progressValue);
  }

  const handleBiltyBackClick = () => {
    setProgress((prevProgress) => (prevProgress > 25 ? prevProgress - 25 : 100))
    backClick(progress);
  }

  const handlePreviewBilty = () => {
    previewBilty();
  }

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={rightSideBarOpen}
      ModalProps={{
        keepMounted: false,
        className: classes.modal,
        BackdropProps: {
          className: classes.backdrop
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        //onBackdropClick: handleClose
      }}
      classes={{
        paper: sideBarType == "paymentDetailSingleSupplier" || sideBarType == "paymentDetailSingleParty" ? classes.addPaymentSupplierrDrawer : sideBarType == "paymentDetails" ? classes.paymentDetailsDrawer : sideBarType == 'reports' ? classes.fromReports : fromBiltyFlow ? classes.biltyDrawer : fromBiltyHome ? classes.drawerTripPaper : fromSimTracking || fromCheckApproval ? classes.simTrackingDrawer : fromAddTrip ? classes.drawerTripPaper : sideBarType && sideBarType == 'truckBook' ? classes.drawerPaperTruckBook : classes.drawerPaper
      }}
    >

      {!titleType &&
        <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} siderBarType={'truckBook'} onClose={handleClose} className={sideBarType == "paymentDetailSingleSupplier" || sideBarType == "paymentDetailSingleParty" ? classes.paymentDetailSingleSupplierTitle : fromPaymentSideBarSupplier ? classes.titlePaymentSupplier : fromBiltyHomeSteps ? classes.biltyHomeStepsTitle : fromSimTracking ? classes.simTrackingTitle : ""}>
          <>
            <div className={titleEighteen ? classes.divTitleV1 : classes.divTitle}>
              {!fromCheckApproval &&
                <>
                  {sideBarTitle ? sideBarTitle : 'Title'}
                </>
              }
              {sideBarType && sideBarType == 'truckBook' &&
                <>
                  {vehicleNumberValue &&
                    <span className={classes.vehicleNumber}> {vehicleNumberValue.vehicleNumberPrefix} < span className={classes.vehicleNumberSuffix}> {vehicleNumberValue.vehicleNumberSuffix}</span></span>
                  }
                  {truckType &&
                    <>
                      <span className={classes.bullet}>•</span>
                      <span className={classes.truckType}>{truckType}</span>
                    </>
                  }
                </>
              }
              {sideBarType && sideBarType == 'checkApproval' &&
                <>
                  <div>
                    <div>
                      {sideBarTitle.map((vnumber, index) => (
                        <span key={index} className={classes.vehicleNumberV1}>{vnumber}</span>
                      ))
                      }
                    </div>
                    <div className={classes.divV1}>
                      {sourceLocation + " - " + destinationLocation}
                    </div>
                  </div>
                </>
              }
            </div>
          </>
        </SideBarDialogTitle >
      }

      {/* ************************************* Title for Bilty.********************************** */}
      {titleType == "biltyFlow" &&
        <>
          {!biltyTimeLine &&
            <DialogTitle className={classes.biltyFlowTitle}>
              <>
                <div className={classes.divV4}>
                  <div className={classes.divV5}>
                    <div className={classes.divTitleBilty}>
                      {!fromCheckApproval &&
                        <>
                          {sideBarTitle ? sideBarTitle : 'Title'}
                        </>
                      }
                    </div>
                    <div className={classes.divStep}>
                      Step {progress / 25} of 4
                    </div>

                  </div>
                  <div>
                    <IconButton className={classes.closeButton} onClick={handleClose}>
                      <CloseIcon className={classes.closeIcon} />
                    </IconButton>
                  </div>

                </div>

                <LinearProgress variant="determinate" value={progress} />
              </>
            </DialogTitle>
          }

          {biltyTimeLine &&
            <DialogTitle className={classes.biltyTimeLineTitle}>
              <div className={classes.divTimeLine}>
                <div className={classes.divTitleBilty}>
                  {sideBarTitle ? sideBarTitle : 'Title'}
                </div>
                <div>
                  <IconButton className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon className={classes.closeIcon} />
                  </IconButton>
                </div>
              </div>
            </DialogTitle>
          }
        </>
      }

      {/* ************************************** Side Bar Title for Reports ****************************************** */}
      {titleType == "reports" &&
        <DialogTitle className={showBackReports ? classes.reportTitleV1 : classes.reportTitle}>
          <div className={classes.divReportsTitle}>
            <div className={classes.divReportAlign}>
              {showBackReports &&
                <div className={classes.mrV1}>
                  <IconButton onClick={backClick}>
                    <ArrowBackIcon className={classes.arrowBackIcon} />
                  </IconButton>
                </div>
              }
              <div className={classes.divTitleReport}>
                {sideBarTitle ? sideBarTitle : 'Title'}

                {sideBarTitle == "Truck Revenue Report" && showBackReports &&
                  <>
                    <div className={classes.vehicleNumberTruckIncome}>
                      {vehicleNumberValue && vehicleNumberValue.map((vehicleNumber) => (
                        <span className={classes.vehicleNumberReport}>{vehicleNumber}</span>
                      ))}
                    </div>
                  </>
                }
                {truckType && showBackReports &&
                  <>
                    <span className={classes.bulletV1}>•</span>
                    <span className={classes.truckType}>{truckType}</span>
                  </>
                }
                {partyNameValue && showBackReports && fromPartyIncomeReport &&
                  <>
                    <div className={classes.partyName}>
                      {partyNameValue}
                    </div>
                  </>
                }
              </div>

            </div>
            <div>
              <IconButton className={classes.closeButton} onClick={handleClose}>
                <CloseIcon className={classes.closeIcon24} />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
      }

      {!dividerNotRequired &&
        <SideBarDialogContent dividers className={fromPaymentSideBarSupplier || sideBarType == "paymentDetailSingleSupplier" || sideBarType == "paymentDetailSingleParty" ? classes.paymentsSupplier : fromTruckIncomeReport || fromPartyIncomeReport || fromProfitLossReport ? classes.truckIncomeReport : fromBiltyHome ? classes.biltyContent : splitDesign ? classes.splitV1 : fromSimTracking ? classes.sideBarDialogContentV1 : ""} >
          {children}
        </SideBarDialogContent>
      }

      {dividerNotRequired &&
        <SideBarDialogContent className={fromBiltyFlow ? classes.biltyContentV2 : fromBiltyHomeSteps ? classes.biltyContentV1 : ""} >
          {children}
        </SideBarDialogContent>
      }

      {action && <>{actionInfo ? actionInfo : null}</>}
      {sideBarType && sideBarType == 'form' && <SideBarDialogActions>
        <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
          Close
        </Button>
        <Button variant="contained" className={confirmText == "Save Trip" ? 'modal-save-trip-cta' : 'modal-save-cta'} onClick={handleSave} disabled={validate}
          classes={{
            disabled: classes.disabledButton
          }}>
          {confirmText ? confirmText : "Save"}
        </Button>
      </SideBarDialogActions>
      }

      {
        sideBarTitle && sideBarTitle == 'Trip Book' && <SideBarDialogActions className={classes.bColorW}>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className='modal-save-cta' onClick={() => handleAddTrip()}>
            Add Trip
          </Button>
        </SideBarDialogActions>
      }

      {sideBarTitle && sideBarTitle == 'Fuel Book' &&
        <SideBarDialogActions className={classes.bColorW}>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className='modal-save-cta' onClick={() => handleAddExpense()}>
            Add Fuel Expense
          </Button>
        </SideBarDialogActions>
      }

      {sideBarTitle && (sideBarTitle == 'Maintenance Book' || sideBarTitle == 'Driver & Other Expenses') &&
        <SideBarDialogActions className={classes.bColorW}>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className='modal-save-cta' onClick={() => handleAddExpense()}>
            Add Entry
          </Button>
        </SideBarDialogActions>
      }

      {sideBarTitle && sideBarTitle == "Document Book" &&
        <SideBarDialogActions className={classes.bColorW}>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addOtherDocument} onClick={() => handleAddExpense()}>
            Add Other Document
          </Button>
        </SideBarDialogActions>
      }

      {sideBarTitle && sideBarTitle == "EMI Book" &&
        <SideBarDialogActions className={classes.bColorW}>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addOtherDocument} onClick={() => handleAddExpense()}>
            {vehicle && vehicle.truckBooks && vehicle.truckBooks.id ? "Add Past Payment" : "Add EMI"}
          </Button>
        </SideBarDialogActions>
      }

      {sideBarTitle && sideBarTitle == "Profit and Loss Report" && sideBarType !== "reports" &&
        <SideBarDialogActions className={classes.bColorW}>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
        </SideBarDialogActions>
      }
      {sideBarTitle && sideBarTitle == "Sim Tracking" &&
        <SideBarDialogActions className={classes.sideBarDialogActionsV1}>
          <Button variant="contained" className={classes.driverDetailsButton} onClick={() => handleDriverDetailClicked()}>
            Add Driver Details
          </Button>
        </SideBarDialogActions>
      }

      {fromCheckApproval &&
        <SideBarDialogActions className={classes.bColorW}>
          <div className={classes.divSupport}>
            Contact Support for help&nbsp;
            <strong>{config&&config.helpCenterConfig&&config.helpCenterConfig.call?config.helpCenterConfig.call:''}</strong>
          </div>
        </SideBarDialogActions>
      }

      {sideBarType == "biltyHome" &&
        <SideBarDialogActions className={classes.bColorW}>
          <Button variant="contained" className={classes.biltyCancel} onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" className={classes.biltyNext} onClick={nextClick}>
            Next
          </Button>
        </SideBarDialogActions>
      }

      {sideBarType == "biltyHomeSteps" &&
        <SideBarDialogActions className={classes.biltyHomeStepsActions}>
          <Button variant="contained" className={classes.createBiltyButton} onClick={createBiltyClick} fullWidth >
            Create Bilty
          </Button>
        </SideBarDialogActions>
      }

      {sideBarType == "biltyCompanyDetails" &&
        <SideBarDialogActions className={classes.bColorGrey}>
          <Button variant="contained" className={classes.biltyContinueButton} onClick={handleBiltyContinueClickStep1} fullWidth>
            Continue
          </Button>
        </SideBarDialogActions>
      }

      {sideBarType == "biltyConsignorConsignee" &&
        <SideBarDialogActions className={classes.biltyConsignorConsigneeActions}>
          <Button variant="contained" className={classes.backButton} onClick={handleBiltyBackClick}>
            Back
          </Button>
          <Button variant="contained" className={checkDataPopulated ? classes.nextButton : classes.disableButton} onClick={handleBiltyContinueClick}>
            Next
          </Button>
        </SideBarDialogActions>
      }

      {sideBarType == "biltyTimeLine" &&
        <>
          {checkStatusAllTrue &&
            <SideBarDialogActions className={classes.biltyTimeLineActions}>
              <Button variant="contained" className={classes.biltyContinueButton} onClick={handlePreviewBilty} fullWidth>
                Preview & Download Bilty
              </Button>
            </SideBarDialogActions>
          }
        </>
      }

      {sideBarType == "reports" &&
        <>
          <SideBarDialogActions className={showBackReports ? classes.truckIncomeReportActionsWhite : classes.truckIncomeReportActions}>
            <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
              Close
            </Button>
            {showDownloadExcel &&
              <Button variant="contained" className={classes.downloadExcelButton} onClick={handleSubmit} >
                <span>
                  Download Excel
                </span>
                <ExcelIcon className={classes.excelIcon} />
              </Button>
            }
            {showViewPdf &&
              <Button variant="contained" className={classes.viewPdfButton} onClick={handleSubmit}>
                <span>
                  View PDF
                </span>
                <PdfIconWhite className={classes.pdfIcon} />
              </Button>
            }
          </SideBarDialogActions>
        </>
      }

      {sideBarType == "paymentDetails" &&
        <>
          <SideBarDialogActions className={classes.paymentSideBarActions} >
            {paidOnline &&
              <>
                <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                  Close
                </Button>
              </>
            }
            {!paidOnline &&
              <div className={classes.divActionsPayment}>
                <div className={classes.divPaymentAlign} >
                  <Button variant="outlined" className={classes.deleteTripCtaV1} onClick={deleteClick}>
                    <DeleteIcon className={classes.deleteIconV1} />&nbsp;Delete
                  </Button>
                </div>
                <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                  Close
                </Button>
              </div>
            }
          </SideBarDialogActions>
        </>
      }

      {(sideBarType == "paymentDetailSingleSupplier" || sideBarType == "paymentDetailSingleParty") &&
        <>
          <SideBarDialogActions className={sideBarTitle == "Choose Trips" ? classes.addPaymentSideBarActionsV1 : classes.addPaymentSideBarActions} >
            {sideBarTitle == "Choose Trips" &&
              <div className={fullyAllocatedFlag ? classes.paymentFullyAllocated : classes.paymentPartiallyAllocated}>
                {fullyAllocatedFlag &&
                  <>
                    <CheckCircleIcon className={classes.doneV1} />
                    <div className={classes.divAlign}><div className={classes.fw300}>{allocatedTextValue}&nbsp;</div> <div>has been fully allocated.</div></div>
                  </>
                }
                {!fullyAllocatedFlag &&
                  <>
                    <ErrorIcon className={classes.errorV1} />
                    <div className={classes.divAlign}><div className={classes.fw300}>{allocatedTextValue}&nbsp;</div> <div>has not been allocated yet.</div></div>
                  </>
                }
              </div>
            }
            <div className={sideBarTitle == "Choose Trips" ? classes.divAlignButtons : ""}>
              {(sideBarTitle == "Add Supplier Payment" || sideBarTitle == "Add Party Payment") &&
                <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                  Close
                </Button>
              }
              {sideBarTitle == "Choose Trips" &&
                <Button variant="contained" className={classes.backButtonSupplier} onClick={backClick}>
                  Back
                </Button>
              }
              <Button variant="contained" classes={{ disabled: classes.confirmDisabled }} className={validate && (sideBarTitle == "Add Supplier Payment" || sideBarTitle == "Add Party Payment") ? classes.chooseTripButtonDisabled : classes.chooseTripButton} onClick={(sideBarTitle == "Add Supplier Payment" || sideBarTitle == "Add Party Payment") ? handleSubmit : chooseTripConfirm} disabled={sideBarTitle == "Choose Trips" && (tripsError || !fullyAllocatedFlag) ? true : false}>
                {confirmText ? confirmText : ""}
              </Button>
            </div>
          </SideBarDialogActions>
        </>
      }

    </Drawer >



  );
};

RightSideBar.propTypes = {
  rightSideBarOpen: PropTypes.bool,
  toggleRightSideBar: PropTypes.func
};
const RightSideBarWithRouter = withRouter(RightSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSideBarWithRouter);
